import { render } from "./CTASection.vue?vue&type=template&id=1a70e6f8&scoped=true"
import script from "./CTASection.vue?vue&type=script&lang=js"
export * from "./CTASection.vue?vue&type=script&lang=js"

import "./CTASection.vue?vue&type=style&index=0&id=1a70e6f8&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a70e6f8"]])

export default __exports__